'use client';
/** @jsxImportSource @emotion/react */

import type { InputLabelProps } from '@mui/material/InputLabel';

import MuiInputLabel from '@mui/material/InputLabel';

export type { InputLabelProps };
export const InputLabel = MuiInputLabel;
